export const ko = {
  // Navigation (Korean)
  explore: '탐색',
  search: '검색',
  create: '게시물 작성',
  messages: '메시지',
  notifications: '알림',
  settings: '설정',
  profile: '프로필',
  logout: '로그아웃',
  home: '홈',
  
  // Authentication
  signin: '로그인',
  signup: '회원가입',
  login: '로그인',
  register: '회원가입',
  email: '이메일',
  password: '비밀번호',
  confirmPassword: '비밀번호 확인',
  firstName: '이름',
  lastName: '성',
  forgotPassword: '비밀번호를 잊으셨나요?',
  alreadyHaveAccount: '이미 계정이 있으신가요? 로그인',
  dontHaveAccount: '계정이 없으신가요? 회원가입',
  
  // Posts & Content
  recent: '최근',
  trending: '인기',
  popular: '인기',
  like: '좋아요',
  likes: '좋아요',
  comment: '댓글',
  comments: '댓글',
  share: '공유',
  delete: '삭제',
  edit: '편집',
  post: '게시물',
  posts: '게시물',
  title: '제목',
  content: '내용',
  tags: '태그',
  noBlogsFound: '블로그를 찾을 수 없습니다. 다른 것을 검색하거나 첫 번째 블로그를 만들어보세요!',
  
  // AI Assistant
  quickActions: '빠른 작업',
  writeCaption: '캡션 작성',
  suggestTopics: '주제 제안',
  improveContent: '콘텐츠 개선',
  creativeIdeas: '창의적 아이디어',
  clearChat: '채팅 지우기',
  aiWritingAssistant: 'AI 글쓰기 도우미',
  poweredByGroq: 'GROQ AI 제공',
  aiGreeting: '안녕하세요! 저는 AI 글쓰기 도우미입니다. 매력적인 콘텐츠 작성, 캡션 작성, 게시물 주제 제안, 글쓰기 개선을 도와드릴 수 있습니다. 오늘은 무엇을 작업하고 싶으신가요?',
  askMeToHelp: '콘텐츠, 캡션, 주제 또는 글쓰기에 대한 도움을 요청하세요...',
  aiThinking: 'AI가 생각하고 있습니다...',
  
  // Chat & Messages
  chat: '채팅',
  noConversationsYet: '아직 대화가 없습니다',
  ideafluxChat: 'IdeaFlux 채팅',
  typeMessage: '메시지를 입력하세요...',
  sendMessage: '메시지 보내기',
  connectingToChat: '채팅에 연결 중...',
  
  // Notifications
  noNotificationsYet: '아직 알림이 없습니다.',
  markAllRead: '모두 읽음으로 표시',
  clearAll: '모두 지우기',
  
  // Settings
  accountSettings: '계정 설정',
  displayName: '표시 이름',
  emailAddress: '이메일 주소',
  languagePreference: '언어 설정',
  privacySecurity: '개인정보 보호 및 보안',
  notificationPreferences: '알림 설정',
  allowDirectMessages: '직접 메시지 허용',
  letOthersMessage: '다른 사용자가 개인 메시지를 보낼 수 있도록 허용',
  likesOnPosts: '게시물 좋아요',
  commentsOnPosts: '게시물 댓글',
  newFollowers: '새 팔로워',
  mentions: '멘션',
  save: '저장',
  deleteAccount: '계정 삭제',
  
  // Notification descriptions
  getNotifiedWhenSomeone: '누군가가 다음을 할 때 알림 받기',
  likesYourPosts: '내 게시물에 좋아요를 누름',
  commentsOnYourPosts: '내 게시물에 댓글을 남김',
  followsYou: '나를 팔로우함',
  mentionsYou: '나를 멘션함',
  chooseNotifications: '받고 싶은 알림을 선택하세요',
  controlWhoInteracts: '누가 나와 상호작용할 수 있는지 제어하세요',
  manageAccountInfo: '계정 정보와 설정을 관리하세요',
  emailCannotBeChanged: '보안상의 이유로 이메일은 변경할 수 없습니다',
  
  // Common
  loading: '로딩 중...',
  cancel: '취소',
  update: '업데이트',
  submit: '제출',
  back: '뒤로',
  next: '다음',
  previous: '이전',
  online: '온라인',
  offline: '오프라인',
  
  // Profile
  editProfile: '프로필 편집',
  noBioYet: '아직 소개가 없습니다.',
  followers: '팔로워',
  following: '팔로잉',
  recentActivity: '최근 활동',
  noPostsYet: '아직 게시물이 없습니다',
  shareFirstPost: '첫 번째 게시물을 공유하세요!',
  bio: '소개',
  dateOfBirth: '생년월일',
  follow: '팔로우',
  unfollow: '언팔로우',
  
  // Search
  discover: '발견',
  findPeopleStories: '당신에게 중요한 사람, 이야기, 아이디어를 찾아보세요',
  searchByName: '이름, 제목 또는 #태그로 검색...',
  searchResults: '검색 결과',
  noResultsFound: '결과를 찾을 수 없습니다',
  peopleFound: '찾은 사람들',
  
  // Settings - Additional keys
  enterDisplayName: '표시 이름을 입력하세요',
  saving: '저장 중...',
  confirmDeleteAccount: '정말로 계정을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
  accountDeletedSuccessfully: '계정이 성공적으로 삭제되었습니다.',
  errorDeletingAccount: '계정 삭제 중 오류가 발생했습니다. 다시 시도해주세요.',
  settingsSavedSuccessfully: '설정이 성공적으로 저장되었습니다!',
  failedToSaveSettings: '설정 저장에 실패했습니다. 다시 시도해주세요.',
  
  // Form component
  pleaseSignInToCreate: '게시물을 작성하려면 로그인하세요.',
  titleRequired: '게시물 발행에는 제목이 필요합니다.',
  contentRequired: '게시물 발행에는 스토리 내용이 필요합니다.',
  contentTooShort: '스토리 내용은 최소 10자 이상이어야 합니다.',
  postUpdatedSuccessfully: '게시물이 성공적으로 업데이트되었습니다!',
  postPublishedSuccessfully: '게시물이 성공적으로 발행되었습니다!',
  pleaseSignInToCreateBlogs: '자신만의 IdeaFlux 블로그를 만들려면 로그인하세요.',
  enterEngagingTitle: '매력적인 제목을 입력하세요...',
  story: '이야기',
  writeYourMasterpiece: '당신의 걸작을 써보세요...',
  addTags: '태그 추가...',
  add: '추가',
  publishPost: '게시물 발행',
  
  // Post component
  linkCopiedToClipboard: '링크가 클립보드에 복사되었습니다! 공유 수가 업데이트되었습니다.',
  youAndOthers: '당신과 {{count}}명의 다른 사람들',
  unknownUser: '알 수 없는 사용자',
  noImage: '이미지 없음',
  deletePost: '게시물 삭제',
  confirmDeletePost: '이 게시물을 삭제하시겠습니까?',
};